import React from "react"
import ConsentAgreement from "./consent-agreement"

const Consents = ({ consents, changeConsentAgreements, textsMapping }) => {
  if (consents) {
    return (
      <section className="payment">
        <h3 className="payment-title">{textsMapping.consentTitle}</h3>
        <section className="checkout-section">
          {consents.map((consent) => {
            return (
              <ConsentAgreement
                consentCode={consent.consentCode}
                consentText={consent.consentText}
                textsMapping={textsMapping}
                consentIsChecked={consent.isChecked}
                changeConsentAgreements={changeConsentAgreements}
                key={consent.consentCode}
              />
            )
          })}
        </section>
      </section>
    )
  }
}

export default Consents
